import React from 'react';

import Layout from '../components/layout';
import Helmet from 'react-helmet';
import SEO from '../components/seo';
import { Container } from 'reactstrap';

import NextPayLogo from './logo_blue.svg';
import BeRightBackImg from './brb.png';

const IndexPage = () => {
  return (
    <Layout showHeader={true}>
      <SEO
        title='NextPay | The all-in-one payment platform for SMEs and entrepreneurs'
        titleTemplate={`%s`}
      />
      <Helmet>
        <body className='landing is-preload' />
      </Helmet>
      <Container
        fluid
        style={{
          height: '100vh',
          display: 'flex',
          padding: 16,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ maxWidth: 500 }}>
          <img
            src={NextPayLogo}
            style={{
              display: 'block',
              width: 160,
              margin: '0 auto',
              marginBottom: 16,
            }}
          />
          <img
            src={BeRightBackImg}
            style={{
              display: 'block',
              maxWidth: 280,
              width: '100%',
              margin: '0 auto',
              marginBottom: 24,
            }}
          />
          <h1
            style={{
              textAlign: 'center',
              fontSize: 40,
              fontWeight: 700,
              color: '#5974FF',
              marginBottom: 16,
            }}
          >
            Be right back!
          </h1>
          <p
            style={{ textAlign: 'center', fontSize: '1rem', marginBottom: 16 }}
          >
            We're currently making some upgrades to our site for a better
            experience. This may take up to a few hours -- please sit tight and
            check back later.
          </p>
          <p
            style={{ textAlign: 'center', fontSize: '1rem', marginBottom: 16 }}
          >
            If you have an urgent concern, please email{' '}
            <strong>
              <a
                href='mailto:support@nextpay.ph'
                style={{
                  color: '#4B68FE',
                  fontWeight: 'bold',
                }}
              >
                support@nextpay.ph
              </a>
            </strong>
          </p>
          <p
            style={{
              textAlign: 'center',
              color: '#828282',
              fontSize: '0.875rem',
            }}
          >
            Support Hours: Daily, 10AM - 6PM (PHT)
          </p>
        </div>
      </Container>
    </Layout>
  );
};

export default IndexPage;
